import React from "react";
import { BrainCircuit, Building2, BellRing, BadgeCheck, Gauge, BarChart3 } from "lucide-react";
import { C, Pill, FeatureCard } from "./shared";

export default function WhyChooseSection() {
  return (
    <section className="bg-white">
      <div className="max-w-7xl mx-auto px-6 py-16 md:py-20">
        <div className="text-center max-w-2xl mx-auto">
          <Pill color={C.navy}>Why Choose SkillConnect</Pill>
          <h2 className="font-display font-black text-3xl md:text-5xl mt-3 tracking-tight" style={{ color: C.navyDeep }}>
            Built for students who want <span style={{ color: C.green }}>more than a resume</span>.
          </h2>
          <p className="text-slate-600 mt-3">Six advantages that turn a profile into a placement.</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-12">
          <FeatureCard icon={BrainCircuit} color={C.green}  delay={0}   title="AI-Powered Skill Matching"
            body="Our matching engine reads your verified skills, projects and CoE badges to surface the roles you'll actually win." />
          <FeatureCard icon={Building2}    color={C.navy}   delay={80}  title="Trusted by Universities & Companies"
            body="Onboarded by leading institutes and recruited by 200+ companies hiring across India." />
          <FeatureCard icon={BellRing}     color={C.orange} delay={160} title="Real-time Job & Internship Alerts"
            body="Get notified the moment a role matches your profile — beat the queue, apply first." />
          <FeatureCard icon={BadgeCheck}   color={C.purple} delay={240} title="Verified Profiles Increase Visibility"
            body="A verified SkillConnect profile signals trust — recruiters see your evidence, not just claims." />
          <FeatureCard icon={Gauge}        color={C.green}  delay={320} title="Improve Your Employability Score"
            body="Track your weekly score, find what's missing, and level up with curated learning paths." />
          <FeatureCard icon={BarChart3}    color={C.navy}   delay={400} title="Data-Driven Career Insights"
            body="See which skills are trending in your domain, which companies hire your peers, and where to focus next." />
        </div>
      </div>
    </section>
  );
}
